<template>
  <div class="flex-auto w-full input-form-select">
    <div class="h-full w-full flex items-center">
      <select :value="modelValue" @input="updateValue($event.target.value)" class="h-full input-form-select__select">
        <option v-if="placeholder" value="" disabled selected>{{placeholder}}</option>
        <option v-for="option in options" :value="option.value">{{option.label}}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: 'Dropdown',
  setup(props, {emit}) {
    const internalValue = ref()
    const updateValue = value => {
      emit('update:modelValue', value)
    }
    return {updateValue, internalValue}
  },
  props: {
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    options: {
      type: Array
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue']
}
</script>